import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNotebook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"notebook, cover"} maskId="square-filled-radius-0-stroke-1-IconNotebook"><path d="M3.5 21.5V2.5H7V21.5H3.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M8 21.5H20.5V2.5H8V21.5ZM12 7V8H16.5V7H12ZM12 11V12H16.5V11H12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNotebook;
